import { storage } from "@/firebase/config";

export const deleteFileOnStorage = (filePath) => {
    const storageRef = storage.ref();
    return storageRef.child(filePath).delete()
    // let result
    // try {
    //     result = await storageRef.child(filePath).delete() 
    // } catch (_) {
    //     result = true
    // }
    // return !result
};

